
<input type="file" style="display: none" (change)="handleFile($event)" #upload accept="image/png,image/jpeg" />

